import { updateBulkResources } from '@dispatch/shared/services';
import { BulkUpdatePostBody, ResultStatus } from '@dispatch/shared/types';
import { useMutation, useQueryClient } from 'react-query';

export const useBulkUpdate = (
  onSuccess: ({ success }: { success: boolean; message?: string }) => void
) => {
  const client = useQueryClient();
  const { mutate, error, status } = useMutation(
    ['bulk-update'],
    async (data: BulkUpdatePostBody) => updateBulkResources(data),
    {
      onSuccess,
      onSettled: (response) => {
        if (response?.success) {
          client.invalidateQueries('resource');
        }
      },
    }
  );

  return {
    upsertBulk: mutate,
    upsertBulkError: error,
    upsertBulkStatus: status as ResultStatus,
  };
};
